import BarChart from '..';
import { useElementProps } from '../../../core/elements';
import { useMenuData } from '../../../primitives/menu/menu';
import { DEFAULT_ORDINAL_PATTERNS_DEFS } from '../../../primitives/theme';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const BarPatterns = () => {
  const {
    patternDefs
  } = useElementProps(BarChart.elements.Theme);
  const {
    showPatterns
  } = useMenuData();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: showPatterns ? DEFAULT_ORDINAL_PATTERNS_DEFS : patternDefs
  });
};